/* eslint-disable max-len */
const translations = {
  fr: {
    customers: {
      customersPageTitle: 'Clients',
      customersPageTitleAdmin: 'Tous les clients',
      couldNotSendInvitationMessage: "Impossible d'envoyer l'invitation",
      couldNotAddCustomerMessage: "Impossible d'ajouter le client",
      missingEmailMessage: 'Veuillez entrer une adresse courriel',
      missingAdvertiserMessage: "Veuillez entrer le nom de l'entreprise",
      invalidEmailMessage: "Votre adresse courriel n'est pas valide",
      missingFullNameMessage: 'Veuillez entrer un nom',
      createACustomer: 'Créer un client',
      sendingInvitation: "Envoi de l'invitation en cours...",
      invitationSendSuccess: 'Invitation envoyée',
      couldNotDeleteCustomer: 'Impossible de supprimer le client, veuillez réessayer.',
      couldNotEditCustomer: "Impossible d'éditer le client, veuillez réessayer.",
      editCustomer: 'Modification du client',
      company: 'Entreprise',
      surname: 'Nom',
      name: 'Prénom',
      fullname: 'Nom',
      email: 'Courriel',
      accountStatus: 'État du compte',
      active: 'Actif',
      invited: 'Invité',
      resendInvitation: 'Renvoyer invitation',
      deleteCustomer: 'Supprimer ce client',
      manage: 'Gérer',
      invitation: 'Invitation',
      contact: 'Contact',
      actions: 'Actions',
      noCustomerToManage: "Il n'y a pas de client à gérer",
      couldNotLoadCustomers: 'Une erreur est survenue lors du chargement des clients',
      activateAccessToFollo: "Donner l'accès à Follo.",
      accessToFolloActivated: "Vous avez donné l'accès permanent à Follo",
      canGiveAccessToFolloLater: "Vous pourrez toutefois donner l'accès à Follo dans la gestion du client.",
      accessToFolloIsPermanent: 'Cette activation est permanente.',
      accessToFolloIsPermanentOnCreation: '$t(accessToFolloIsPermanent) $t(canGiveAccessToFolloLater)',
      deletedCustomerSuccess: 'Le client a été supprimé avec succès',
      editedCustomerSuccess: 'Le client a été modifié avec succès',
      createdCustomerSuccess: 'Le client a été créé avec succès',
      folloAccess: 'Accès à Follo',
      callSign: 'Station',
    },
  },
  en: {
    customers: {
      customersPageTitle: 'Customers',
      customersPageTitleAdmin: 'All Customers',
      couldNotSendInvitationMessage: 'Could not send invitation',
      couldNotAddCustomerMessage: 'Could not add the customer',
      missingAdvertiserMessage: 'Please entrer the name of the company',
      missingEmailMessage: 'Please enter an email address',
      invalidEmailMessage: 'Enter a valid email address',
      missingFullNameMessage: 'Please enter a name',
      createACustomer: 'Create a Customer',
      sendingInvitation: 'Sending invitation...',
      invitationSendSuccess: 'Invitation sent successfully',
      couldNotDeleteCustomer: 'Could not delete customer',
      couldNotEditCustomer: 'Could not edit customer',
      editCustomer: 'Edit Customer',
      company: 'Company',
      surname: 'Surname',
      name: 'Name',
      fullname: 'Name',
      email: 'Email',
      accountStatus: 'Account status',
      active: 'Active',
      invited: 'Invited',
      resendInvitation: 'Resend invitation',
      deleteCustomer: 'Delete customer',
      manage: 'Manage',
      invitation: 'Invitation',
      contact: 'Contact',
      actions: 'Actions',
      noCustomerToManage: 'There is no customer to manage',
      couldNotLoadCustomers: 'Could not load customers',
      activateAccessToFollo: 'Give access to Follo.',
      accessToFolloActivated: 'Permanent access to Follo has been given',
      canGiveAccessToFolloLater: 'You can still give the access later in the customer management page',
      accessToFolloIsPermanent: "Once you give access to a customer, you can't take it back.",
      accessToFolloIsPermanentOnCreation: '$t(accessToFolloIsPermanent) $t(canGiveAccessToFolloLater)',
      deletedCustomerSuccess: 'Customer has been successfully deleted',
      editedCustomerSuccess: 'Customer has been successfully edited',
      createdCustomerSuccess: 'Customer has been successfully created',
      folloAccess: 'Follo Access',
      callSign: 'Station',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/i18n/customers.js